import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';

import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css'],
})
export class ConfirmDialogComponent implements OnInit {
  @Input() bodyContent: string;
  @Input() headerContent: string;

  @Input() showBody: boolean = true;
  @Input() showHeader: boolean = false;

  @Input() cancelButtonClasses: string = 'btn btn-outline-secondary';
  @Input() cancelButtonText: string = 'Cancel';
  @Input() confirmButtonClasses: string = 'btn btn-primary';
  @Input() confirmButtonText: string = 'Confirm';

  @Output() result: EventEmitter<string> = new EventEmitter();

  @ViewChild('confirmDialog', { static: true }) confirmDialogTemplate: TemplateRef<any>;

  modalRef: NgbModalRef | null;

  constructor(private modalService: NgbModal) {}

  // Component lifecycle events
  ngOnInit() {}

  // Component functions
  close(result: string) {
    this.modalRef!.close(result);
    this.resetDialog();
  }

  open(content: string) {
    this.bodyContent = content;
    return this.modalService.open(this.confirmDialogTemplate);
  }

  openAndResult() {
    this.modalRef = this.modalService.open(this.confirmDialogTemplate);
    this.modalRef.result.then(
      (result) => {
        this.result.emit(result);
        this.resetDialog();
      },
      (reason) => {
        this.result.emit(reason);
        this.resetDialog();
      }
    );
  }

  resetDialog() {
    this.bodyContent = '';
    this.cancelButtonClasses = 'btn btn-outline-secondary';
    this.cancelButtonText = 'Cancel';
    this.confirmButtonClasses = 'btn btn-primary';
    this.confirmButtonText = 'Confirm';
    this.modalRef = null;
    this.showBody = true;
    this.showHeader = false;
  }
}
